module.exports = __webpack_public_path__ + "static/media/sdump-bnb.a8bcd7c2.png";